import { RouteConfigProvider } from '@/context/route-config';
import FuturesAppropriatenessTestForm from '@/features/futures/components/appropriateness-test-form';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';

const FuturesAppropriatenessTestPage = () => {
  return (
    <FuturesAppropriatenessTestLayout>
      <RouteConfigProvider
        config={{
          clientCategorisationTreatment: '/futures/client-categorisation/treatment',
          appropriatenessTestResult: '/futures/appropriateness-test/result',
        }}
      >
        <FuturesAppropriatenessTestForm />
      </RouteConfigProvider>
    </FuturesAppropriatenessTestLayout>
  );
};
FuturesAppropriatenessTestPage.displayName = 'FuturesAppropriatenessTestPage';

export default FuturesAppropriatenessTestPage;
